export enum FieldSortTypesEnum {
  string,
  number,
  date,
  boolean,
}
